<template>
  <router-link
    :to="{name: 'player_unban', params: {playerId: playerId, unbanId: unbanId}}"
  >
    {{lable}} {{unbanId}}
  </router-link>
</template>

<script>
export default {
  name: 'PlayerUnbanLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    unbanId: {
      type: Number,
      required: true,
    },

    lable: {
      type: String,
      default: 'Unban'
    }
  },
};
</script>
